import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./routes/Home";
import DiscoverPage from "./routes/DiscoverPage";
import MatchesPage from "./routes/Matches";
import MessagesPage from "./routes/Messages";
import ProfilePage from "./routes/Profile";
import HelpPage from "./routes/HelpPage";
import Footer from "./components/Footer";
import AboutPage from "./routes/AboutPage";
import Navbar from "./components/Navbar";
import ContactSection from "./components/homeComponents/Contact";
import WaitlistPage from "./routes/WaitingListPage";
import AdminPage from "./routes/AdminPage";
import TshirtPage from "./components/homeComponents/TShirtPage";
import PreorderPage from "./routes/PreorderPage";
import { trackPageView } from "./routes/Analytics";
import { useEffect } from "react";
import TermsPage from "./routes/TermsPage";
import PrivacyPage from "./routes/PrivacyPage";
import GuidelinesPage from "./routes/Guidelinespage";
import PricingPage from "./routes/PricingPage";
import LawEnforcementPage from "./routes/LawEnforcementPage";
import ChildSafetyPage from "./routes/ChildSafetyPage";
import SafetyToolsPage from "./routes/SafetyToolsPage";
import DeleteAccountPage from "./routes/DeleteAccountPage";
import RefundsPage from "./routes/RefundsPage";
import SupportPage from "./routes/SupportPage";

// ── Tracks every route change as a GA4 pageview automatically ─────────────────
function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    // Map paths to human-readable titles for GA reports
    const titles = {
      "/": "Home",
      "/about": "About",
      "/contact": "Contact",
      "/waitlist": "Waitlist",
      "/preorder": "Preorder — T-Shirt",
      "/preorder-tshirt": "T-Shirt Teaser",
      "/admin": "Admin",
      "/help": "Help",
      "/terms": "Terms of Service",
      "/privacy": "Privacy Policy",
      "/guidelines": "Community Guidelines",
      "/pricing": "Pricing",
      "/law-enforcement": "Law Enforcement Guidelines",
      "/child-safety": "Child Safety Standards",
      "/safety-tools": "Reporting & Blocking",
      "/delete-account": "Delete Account",
      "/refunds": "Refunds & Cancellation",
      "/support": "Contact & Support",
    };
    const title = titles[location.pathname] ?? location.pathname;
    trackPageView(location.pathname + location.search, title);
  }, [location]);
}

function App() {
  usePageTracking();
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactSection />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/preorder-tshirt" element={<PreorderPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/guidelines" element={<GuidelinesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/law-enforcement" element={<LawEnforcementPage />} />
        <Route path="/child-safety" element={<ChildSafetyPage />} />
        <Route path="/safety-tools" element={<SafetyToolsPage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path="/refunds" element={<RefundsPage />} />
        <Route path="/support" element={<SupportPage />} />
        {/* <Route path="/matches" element={<MatchesPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/help" element={<HelpPage />} />  */}
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
